import { render } from "./Sell.vue?vue&type=template&id=6a25fa70"
import script from "./Sell.vue?vue&type=script&lang=js"
export * from "./Sell.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/buildings/shop/Sell.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6a25fa70"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6a25fa70', __exports__)) {
    api.reload('6a25fa70', __exports__)
  }
  
  module.hot.accept("./Sell.vue?vue&type=template&id=6a25fa70", () => {
    api.rerender('6a25fa70', render)
  })

}


export default __exports__